import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_PST, LINE_ITEM_QST, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the PST or QST line item (only one is ever present per transaction,
 * and only in the provinces that charge a provincial sales tax separately from GST/HST).
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemPstQstMaybe = props => {
  const { lineItems, intl } = props;

  const pstOrQstLineItem = lineItems.find(
    item => (item.code === LINE_ITEM_PST || item.code === LINE_ITEM_QST) && !item.reversal
  );

  return pstOrQstLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.pstQst" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, pstOrQstLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemPstQstMaybe;
